/**
 * AS TRAINING — i18n configuration
 *
 * - Auto-detects browser language on first visit
 * - Persists user's choice in localStorage under `astraining-lang`
 * - Default fallback: English (en)
 * - Supports: en, es, pt
 *
 * Extending to a new language:
 *   1. Add a new locale file under /src/i18n/locales/{code}.json
 *   2. Import it below and add to `resources`
 *   3. Add the flag/label to LangSwitcher.jsx
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";

export const SUPPORTED_LANGUAGES = ["en", "es", "pt"];
export const DEFAULT_LANGUAGE = "en";
export const STORAGE_KEY = "astraining-lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    // Normalize regional variants: en-US -> en, pt-BR -> pt, es-419 -> es
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
      // Normalize any raw detected code (e.g. "en-US", "pt-BR", "en-US@posix")
      // to the base 2-letter code (en/es/pt) before it is cached/persisted.
      convertDetectedLanguage: (lng) => {
        const base = String(lng || "").toLowerCase().split(/[-_@]/)[0];
        return SUPPORTED_LANGUAGES.includes(base) ? base : DEFAULT_LANGUAGE;
      },
    },
    react: { useSuspense: false },
    returnEmptyString: false,
  });

export default i18n;
